<template>
  <div class="changeName">
    <van-field class="input" placeholder="请输入姓名" v-model="username" />
    <div class="btn" @click="changeName">保存</div>
  </div>
</template>

<script>
import { Field, Button } from "vant";
export default {
  name: "ChangeName",
  components: {
    [Field.name]: Field,
    [Button.name]: Button
  },
  data() {
    return {
      username: ""
    };
  },
  methods: {
    changeName() {
      console.log(this.username);
      this.$router.replace({ name: "MyCard" });
    }
  }
};
</script>

<style lang="scss" scoped>
.changeName {
  .input {
    margin-top: 0.2rem;
  }
  .btn {
    margin: 0.36rem 0.3rem 0 0.3rem;
    background: #ff410a;
    line-height: 0.7rem;
    text-align: center;
    border-radius: 0.16rem;
    color: #ffffff;
    letter-spacing: 0.06rem;
  }
}
</style>
